import { gql } from "apollo-angular";

export const GET_US_CALCULATOR_FIELD_ITEMS = gql`
  query getUsCalculatorFieldItems(
    $publisherId: UUID!
    $classification: String!
    $subcategory: String!
    $inputName: String!
  ) {
    getUsCalculatorFieldItems(
      publisherId: $publisherId
      classification: $classification
      subcategory: $subcategory
      inputName: $inputName
    ) {
      keyValue
      displayValue
      defaultValue
      isDefault
    }
  }
`;

export const GET_US_CALCULATOR_PRODUCTS = gql`
  query getUsCalculatorProducts($publisherId: UUID!) {
    getUsCalculatorProducts(publisherId: $publisherId) {
      keyValue
      displayValue
      defaultValue
      isDefault
    }
  }
`;

export const GET_CALCULATION_INPUT_BY_SUBCATEGORY = gql`
  query calculationInputsBySubcategory(
    $publisherId: UUID!
    $classification: String!
    $subcategory: String!
  ) {
    calculationInputsBySubcategory(
      publisherId: $publisherId
      classification: $classification
      subcategory: $subcategory
    ) {
      id
      keyValue
      inputName
      inputType
      displayValue
      defaultValue
      isDefault
      dependsOnField
      dependsOnValue
    }
  }
`;

export const GET_CALCULATION_INPUT_BY_MULTIPLE_SUBCATEGORY = gql`
  query calculationInputsByMultipleSubcategory(
    $publisherId: UUID!
    $classification: String!
    $subcategory: [String]!
  ) {
    calculationInputsByMultipleSubcategory(
      publisherId: $publisherId
      classification: $classification
      subcategory: $subcategory
    ) {
      id
      subcategory
      inputName
      inputType
      keyValue
      displayValue
      defaultValue
      isDefault
      dependsOnField
      dependsOnValue
    }
  }
`;

export const GET_PAGE_VALUES_FOR_PRODUCT = gql`
  query getPageValuesForProductType(
    $publisherId: UUID!
    $classification: String!
  ) {
    getPageValuesForProductType(
      publisherId: $publisherId
      classification: $classification
    ) {
      inputName
      defaultValue
      isDefault
    }
  }
`;

export const GET_DEPENDANT_FIELD_ITEMS = gql`
  query getDependantFieldItems(
    $publisherId: UUID!
    $classification: String!
    $subcategory: String!
    $dependsOnField: String!
    $dependsOnValue: String!
  ) {
    getDependantFieldItems(
      publisherId: $publisherId
      classification: $classification
      subcategory: $subcategory
      dependsOnField: $dependsOnField
      dependsOnValue: $dependsOnValue
    ) {
      keyValue
      inputName
      inputType
      displayValue
      defaultValue
      isDefault
    }
  }
`;

export const GET_CALCULATION_INPUTS_BY_PUBLISHER = gql`
  query calculationInputsByPublisher($publisherId: UUID!) {
    calculationInputsByPublisher(publisherId: $publisherId) {
      id
      publisherId
      classification
      subcategory
      keyValue
      inputName
      inputType
      displayValue
      defaultValue
      isDefault
      dependsOnField
      dependsOnValue
      enabled
      origin
      sortOrder
    }
  }
`;

export const CREATE_US_CALCULATOR_FIELD_ITEM = gql`
  mutation createUsCalculatorFieldItem(
    $publisherId: String!
    $classification: String!
    $subcategory: String!
    $inputName: String!
    $keyValue: String!
    $displayValue: String
    $default: Boolean
    $enabled: Boolean
    $sortOrder: Int
    $dependsOnField: String
    $dependsOnValue: String
  ) {
    createUsCalculatorFieldItem(
      publisherId: $publisherId
      classification: $classification
      subcategory: $subcategory
      inputName: $inputName
      keyValue: $keyValue
      displayValue: $displayValue
      isDefault: $default
      enabled: $enabled
      sortOrder: $sortOrder
      dependsOnField: $dependsOnField
      dependsOnValue: $dependsOnValue
    ) {
      id
      inputName
      displayValue
    }
  }
`;

export const CREATE_CALCULATION_INPUT = gql`
  mutation createCalculationInput($input: CalculationInputInput!) {
    createCalculationInput(input: $input) {
      id
    }
  }
`;

export const DELETE_CALCULATION_INPUT = gql`
  mutation deleteCalculationInput($id: UUID!) {
    deleteCalculationInput(id: $id)
  }
`;
